import { useEffect, useRef, useState } from 'react';
import closeIcon from '../../Assets/Icons/close.svg';
import userIcon from '../../Assets/Icons/userIcon.png';
import userRank from '../../Assets/Icons/LeaderBoard/userRank.png';
import Rank1 from '../../Assets/Icons/LeaderBoard/Rank1.png';
import Rank2 from '../../Assets/Icons/LeaderBoard/Rank2.png';
import Rank3 from '../../Assets/Icons/LeaderBoard/Rank3.png';
import LttsLogoicon from '../../Assets/Icons/LttsLogo.png';
import UDSLogo from '../../Assets/logo/logo.png';
import { useMsal } from '@azure/msal-react';
import { jsPDF } from 'jspdf';
import './style.css';
import "./OpenSans-bold";
import "./OpenSans-normal";

const ContributorTable = ({ onClose, data }) => {
  const closeButtonRef = useRef(null);
  const { accounts } = useMsal();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, []);

  const trimName = (name) => {
    if (!name) return '';
    return name.split(' ').slice(0, 2).join(' ');
  };

  const top3 = data.slice(0, 3);
  const filteredData = data.slice(3);
  const currentUser = data.find(
    (item) => item.email.toLowerCase() === accounts[0]?.username.toLowerCase()
  );

  const Rank = currentUser?.rank || 'N/A';
  const hasPublished = currentUser?.publishedCount > 0;

  const handleDownloadCertificate = () => {
    const userName = accounts[0]?.name || "Anonymous";
    const rank = String(Rank || "Unranked");

    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Outer Blue Border
    doc.setDrawColor("#0663A7");
    doc.setLineWidth(100);
    doc.rect(0, 0, pageWidth, pageHeight, "S");

    // Inner Golden Border
    const inset = 50;
    doc.setDrawColor("goldenrod");
    doc.setLineWidth(4);
    doc.rect(inset, inset, pageWidth - inset * 2, pageHeight - inset * 2, "S");

    // LTTS Logo
    const logoWidth = 400;
    const logoHeight = 60;
    const logoX = (pageWidth - logoWidth) / 2;
    doc.addImage(LttsLogoicon, "PNG", logoX, 70, logoWidth, logoHeight);

    // Heading
    doc.setFont("OpenSans", "bold");
    doc.setFontSize(24);
    const heading = "Certification of Completion";
    doc.setTextColor("#000000");
    doc.text(heading, (pageWidth - doc.getTextWidth(heading)) / 2, 210);

    // Subheading
    doc.setFont("OpenSans", "normal");
    doc.setFontSize(14);
    doc.text("This is to Certify that", (pageWidth - doc.getTextWidth("This is to Certify that")) / 2, 280);

    // Name
    doc.setFont("OpenSans", "bold");
    doc.setFontSize(24);
    doc.text(userName, (pageWidth - doc.getTextWidth(userName)) / 2, 310);

    // Rank Message
    doc.setFont("OpenSans", "normal");
    doc.setFontSize(18);
    const achive = "Has Achieved Rank of";
    doc.text(achive, (pageWidth - doc.getTextWidth(achive)) / 2, 410);

    doc.setFont("OpenSans", "bold");
    doc.setFontSize(20);
    doc.text(rank, (pageWidth - doc.getTextWidth(rank)) / 2, 460);

    // Contributor Message
    doc.setFont("OpenSans", "normal");
    doc.setFontSize(18);
    const contri = "as a Contributor to";
    doc.text(contri, (pageWidth - doc.getTextWidth(contri)) / 2, 510);

    // UDS Logo
    const logo2Width = 60;
    const logo2Height = 60;
    doc.addImage(UDSLogo, "PNG", (pageWidth - logo2Width) / 2, 540, logo2Width, logo2Height);

    // Description
    const paraText = `Unified Dev Suite is an in-house solution accelerator for LTTS developers. It's a web-based frontend and backend library that allows users to consume and contribute reusable components and APIs to and from their projects.`;
    doc.setFont("OpenSans", "normal");
    doc.setFontSize(12);
    doc.setTextColor("#0077cf");
    const wrappedPara = doc.splitTextToSize(paraText, pageWidth - 120);
    doc.text(wrappedPara, 300, 630, { align: "center" });

    // Date
    doc.setFont("OpenSans", "italic");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    const dateStr = `Date: ${new Date().toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })}`;
    doc.text(dateStr, pageWidth - 150, pageHeight - 70);

    doc.save("Certificate.pdf");
  };

  const renderCard = (user, rankImage, bgClass, isCenter = false) => (
    <div className={`relative group z-[60] ${isCenter ? 'scale-110' : ''}`}>
      <div className={`bg-cover bg-center rounded-lg ${bgClass} flex flex-col items-center justify-center ${isCenter ? 'w-[110px] h-[130px]' : 'w-[88px] h-[105px]'}`}>
        <img
          src={userRank}
          alt="user badge"
          className={`absolute ${isCenter ? 'top-[-25px] w-[50px] h-[50px]' : 'top-[-22px] w-[44px] h-[44px]'} left-1/2 transform -translate-x-1/2`}
        />
        <div className="pt-[25px] h-full flex flex-col items-center justify-center">
          <p className="text-[11px] font-bold text-white text-center">{trimName(user?.senderName)}</p>
          <img src={rankImage} alt="rank" className={`${isCenter ? 'w-[48px] h-[48px]' : 'w-[22px] h-[22px]'} mb-2`} />
        </div>
      </div>
      <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 bg-[#000000bd] border border-gray-300 rounded-md opacity-0.9 shadow-md p-2 text-xs text-white w-auto max-w-[220px] text-center break-words opacity-0 group-hover:opacity-100 transition-opacity z-[60]">
        <p>Email: {user?.email}</p>
        <p>Components: {user?.publishedCount}</p>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 flex pt-5 justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded shadow-custom text-black w-[80vw] max-h-[90vh] border border-gray-600 relative z-20">
        <div className="sticky top-0 bg-[#002746] text-white h-12 flex items-center justify-between px-2 shadow-custom z-10">
          <h1>Leaderboard</h1>
          <button onClick={onClose} aria-label="Close" className="rounded-full hover:bg-[#70809087]" ref={closeButtonRef}>
            <img src={closeIcon} alt="close" className="w-8 h-8" />
          </button>
        </div>

        <div className="px-4 h-[73vh] overflow-hidden">
          <div className="sticky top-0 bg-white pt-4 pb-2 z-[55]">
            <div className="relative flex justify-end items-center gap-2">
              <img src={userIcon} alt="user" className="w-10 h-10" />
              <p>Your Rank</p>
              <p className="rounded-full bg-[#002746] text-white text-center w-8 h-8 leading-8 cursor-pointer">{Rank}</p>

              {hasPublished && (
                <div className="relative" onClick={() => setDropdownOpen((prev) => !prev)}>
                  <p className="cursor-pointer">▼</p>
                  {dropdownOpen && (
                    <div className="absolute right-0 mt-1 bg-white border border-gray-300 shadow-lg rounded z-50 w-[180px]">
                      <button onClick={handleDownloadCertificate} className="px-4 py-2 text-sm hover:bg-gray-100 w-full text-left">
                        Download Certificate
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="flex flex-row items-center justify-center gap-2 mt-4">
              {renderCard(top3[1], Rank2, 'bg-[#193c58]')}
              {renderCard(top3[0], Rank1, 'bg-[#002746]', true)}
              {renderCard(top3[2], Rank3, 'bg-[#193c58]')}
            </div>
          </div>

          <div className="mt-4 h-[50%] 2xl:h-[66%] overflow-y-auto">
            <table className="w-full">
              <thead className="bg-[#002746] border-b border-gray-200 text-white sticky top-0 z-[50]">
                <tr>
                  <th className="text-left p-2">Rank</th>
                  <th className="text-left p-2">Name</th>
                  <th className="text-left p-2">Email</th>
                  <th className="text-left p-2">Component count</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((user, index) => (
                  <tr key={index} className="border-b border-gray-200">
                    <td className="text-left p-2">{user.rank}</td>
                    <td className="text-left p-2">{user.senderName}</td>
                    <td className="text-left p-2">{user.email}</td>
                    <td className="text-left p-2">{user.publishedCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="sticky bottom-0 bg-white w-full flex justify-end p-2 rounded-b-[4px] gap-3" style={{
          boxShadow: 'rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px',
        }}>
          <button onClick={onClose} className="px-4 py-2 bg-[#002746] border-2 text-white rounded-md">
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContributorTable;
